export default __webpack_public_path__ + "assets/images/e2b1c3689991673d2a3b84547353b8b8.png";